<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/s173/s173.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">17.3中控副驾双联屏</div>
                <div class="detail-banner-desc">3K 高分 In-Cell Touch 中控副驾联屏。</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>

                    <div class="detail-desc">
                        <div>
                            3K 高分 In-Cell Touch 中控副驾联屏<br />
                        </div>
                        <div>
                            窄边框 & 薄型化<br />
                        </div>
                        <div>
                            高亮度 & 超高对比度<br />
                        </div>
                        <div>
                            高 DCI-P3 色域<br />
                        </div>
                        <div>
                            硬件级低蓝光护眼方案
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/s173/s173-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                
                                <div class="spec-item">
                                    <div class="v">In-Cell Touch</div>
                                    <div class="k">触控技术</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Edge type</div>
                                    <div class="k">背光技术</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2880x2x1620</div>
                                    <div class="k">分辨率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">850nits</div>
                                    <div class="k">亮度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1,500 : 1</div>
                                    <div class="k">对比度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">93% DCI-P3</div>
                                    <div class="k">色域</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">LTPS-TFT LCD</div>
                                    <div class="k">面板技术</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '17.3中控副驾双联屏 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/s173.html'
};

import { createApp } from 'vue';
import App from './s173.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./s173.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
